import {
  placeOrderCall,
  getOrdersCall,
  getSingleOrderCall,
  executePaypalRequest,
  validateDiscountCall
} from "../services/mightyWifiApi";
import setAuthorizationToken from "../utils/setAuthorizationToken";
import {
  PLACE_ORDER_SUCCESS,
  GET_ALL_ORDER_SUCCESS,
  GET_ORDER_SUCCESS,
  CLEAR_ORDER_RESULT
} from "./types";
import { SET_CURRENT_USER } from "./types";
export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user
  };
}
export function placeOrder(orderPayload) {
  return dispatch => {
    return placeOrderCall(orderPayload).then(res => {
      if (res.status) {
        localStorage.removeItem("sessionId");
        dispatch({
          type: PLACE_ORDER_SUCCESS,
          order: Object.assign({}, res)
        });
      }
    });
  };
}

export function placePaypalOrder(orderPayload) {
  return dispatch => {
    return executePaypalRequest(orderPayload).then(res => {
      if (res.status) {
        console.log("placeOrderCall", res.data);
        dispatch({
          type: PLACE_ORDER_SUCCESS,
          order: Object.assign({}, res)
        });
      }
    });
  };
}

export function clearOrderResult() {
  return dispatch => {
    dispatch({
      type: CLEAR_ORDER_RESULT,
      order: {}
    });
  };
}

export function getAllOrders() {
  return dispatch => {
    return getOrdersCall()
      .then(res => {
        if (res.status) {
          dispatch({
            type: GET_ALL_ORDER_SUCCESS,
            orderslist: Object.assign([], res.data)
          });
        }
      })
      .catch(error => {
        if (error.response.status == 401) {
          localStorage.removeItem("jwtToken");
          setAuthorizationToken(false);
          dispatch(setCurrentUser({}));
        }
      });
  };
}

export function getSingleOrder(orderId) {
  return dispatch => {
    return getSingleOrderCall(orderId)
      .then(res => {
        if (res.status) {
          dispatch({
            type: GET_ORDER_SUCCESS,
            orderDetail: Object.assign([], res.data)
          });
        }
      })
      .catch(error => {
        if (error.response.status == 401) {
          localStorage.removeItem("jwtToken");
          setAuthorizationToken(false);
          dispatch(setCurrentUser({}));
        }
      });
  };
}


export function validateDiscount(payload){
  return dispatch => {
    return validateDiscountCall(payload)
  }
}



// WEBPACK FOOTER //
// ./src/modules/actions/orderActions.js